<script setup lang="ts">
// Emit for close button action
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import { useI18n } from "@/apps/merchant3/composables/useI18n";

const { t } = useI18n();
const emit = defineEmits<{
  (e: "close"): void;
}>();

const handleClose = () => {
  emit("close");
};
</script>

<template>
  <div class="text-center px-4">
    <!-- Not approved illustration -->
    <div class="mb-4">
      <img
        :src="useAsset('img/offers/assets/not-approved-icon.png')"
        :alt="t('NOT_APPROVED')"
        class="not-approved-img"
      />
    </div>

    <!-- Status message -->
    <h2 class="text-danger mb-3">{{ t("USER_NOT_APPROVED") }}</h2>
    <p class="text-secondary mb-5">
      {{ t("NO_OFFERS_FOUND_MESSAGE") }}
    </p>

    <!-- Close button -->
    <button class="btn btn-success btn-lg w-100" @click="handleClose">
      {{ t("CLOSE") }}
    </button>
  </div>
</template>

<style scoped>
.not-approved-img {
  width: 180px;
  height: 180px;
}

.btn-success {
  background-color: #0b8457;
  border-color: #0b8457;
  border-radius: 4px;
  padding: 12px;
  font-size: 18px;
}
</style>
